import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7bcffaa3&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=7bcffaa3&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bcffaa3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zhenzhaopin\\xxh-zhaopin-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7bcffaa3')) {
      api.createRecord('7bcffaa3', component.options)
    } else {
      api.reload('7bcffaa3', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=7bcffaa3&scoped=true", function () {
      api.rerender('7bcffaa3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/costPlatform/components/my_font_style/index.vue"
export default component.exports